import axios from "axios";

// const BASE_URL="https://cfa-webapp-autotag-dev.azurewebsites.net"; // Dev URl
const BASE_URL="https://edsprodapi.myhcl.com/GenalytixBackendProd"; // Main URl
const SUBSCRIPTION_KEY="4a7bc3b722a54e4796bc1e030fc624ed";

// Feedback API integration
export async function sendFeedback({ user_email, is_like, user_feedback_message, user_query, dashboard, sql_query, accessToken }) {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/feedback`,
      {
        user_email,
        is_like,
        user_feedback_message,
        user_query,
        dashboard,
        sql_query
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
      }
    );
    return response.data;
  } catch (error) {
    // Standardize error handling
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || "Feedback submission failed");
    }
    throw new Error("Feedback submission failed");
  }
}

export async function chatApi({ userQuery, dashboard, accessToken }) {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/chat`,
      {
        user_query: userQuery,
        dashboard: dashboard
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": SUBSCRIPTION_KEY
        }
      }
    );
    return response.data;

  // Mock response for testing without backend

  // return {
  //     "textData": "This section contains descriptive text or summary information.",
  //     "tableResponse":{
  //       "headers": ["Month", "Revenue", "Profit", "Loss"],
  //       "rows": [
  //         ["Jan", 100, 30, 10],
  //         ["Feb", 120, 40, 5],
  //         ["March", 120, 40, 20],
  //         ["April", 120, 40, 30],
  //         ["May", 120, 40, 2],
  //         ["June", 120, 40, 9],
  //       ]
  //     },
  //     "visualizationData": {
  //     "axes": {
  //       "x": [
  //         { "id": "quarter", "labels": ["AMJ25", "JAS25"] },
  //         {
  //           "id": "week",
  //           "labels": [
  //             "30-May-2025", "13-Jun-2025", "25-Apr-2025", "27-Jun-2025", "02-May-2025",
  //             "18-Apr-2025", "20-Jun-2025", "06-Jun-2025", "23-May-2025", "11-Apr-2025",
  //             "16-May-2025", "09-May-2025", "04-Apr-2025"
  //           ]
  //         }
  //       ],
  //       "y": [
  //         { "id": "metric", "labels": ["totalfirm", "totalopportunity"] }
  //       ]
  //     },
  //     "measure": { "id": "value", "label": "USD (millions)" },
  //     "data": [
  //       { "quarter": "AMJ25", "week": "30-May-2025", "metric": "totalfirm", "value": 2966.4139 },
  //       { "quarter": "AMJ25", "week": "30-May-2025", "metric": "totalopportunity", "value": 488.372 },
  //       { "quarter": "AMJ25", "week": "13-Jun-2025", "metric": "totalfirm", "value": 3051.819 },
  //       { "quarter": "AMJ25", "week": "13-Jun-2025", "metric": "totalopportunity", "value": 409.2156 },
  //       { "quarter": "AMJ25", "week": "25-Apr-2025", "metric": "totalfirm", "value": 2879.1194 },
  //       { "quarter": "AMJ25", "week": "25-Apr-2025", "metric": "totalopportunity", "value": 582.3684 },
  //       { "quarter": "AMJ25", "week": "27-Jun-2025", "metric": "totalfirm", "value": 3217.8983 },
  //       { "quarter": "AMJ25", "week": "27-Jun-2025", "metric": "totalopportunity", "value": 237.398 },
  //       { "quarter": "AMJ25", "week": "02-May-2025", "metric": "totalfirm", "value": 2832.2929 },
  //       { "quarter": "AMJ25", "week": "02-May-2025", "metric": "totalopportunity", "value": 631.0372 },
  //       { "quarter": "AMJ25", "week": "18-Apr-2025", "metric": "totalfirm", "value": 2811.6956 },
  //       { "quarter": "AMJ25", "week": "18-Apr-2025", "metric": "totalopportunity", "value": 657.4757 },
  //       { "quarter": "AMJ25", "week": "20-Jun-2025", "metric": "totalfirm", "value": 3099.7574 },
  //       { "quarter": "AMJ25", "week": "20-Jun-2025", "metric": "totalopportunity", "value": 362.0118 },
  //       { "quarter": "AMJ25", "week": "06-Jun-2025", "metric": "totalfirm", "value": 3068.8622 },
  //       { "quarter": "AMJ25", "week": "06-Jun-2025", "metric": "totalopportunity", "value": 398.8506 },
  //       { "quarter": "AMJ25", "week": "23-May-2025", "metric": "totalfirm", "value": 2929.0282 },
  //       { "quarter": "AMJ25", "week": "23-May-2025", "metric": "totalopportunity", "value": 546.8856 },
  //       { "quarter": "AMJ25", "week": "11-Apr-2025", "metric": "totalfirm", "value": 2797.026 },
  //       { "quarter": "AMJ25", "week": "11-Apr-2025", "metric": "totalopportunity", "value": 669.0924 },
  //       { "quarter": "AMJ25", "week": "16-May-2025", "metric": "totalfirm", "value": 2902.2549 },
  //       { "quarter": "AMJ25", "week": "16-May-2025", "metric": "totalopportunity", "value": 577.4266 },
  //       { "quarter": "AMJ25", "week": "09-May-2025", "metric": "totalfirm", "value": 2885.9253 },
  //       { "quarter": "AMJ25", "week": "09-May-2025", "metric": "totalopportunity", "value": 600.4812 },
  //       { "quarter": "AMJ25", "week": "04-Apr-2025", "metric": "totalfirm", "value": 2488.9889 },
  //       { "quarter": "AMJ25", "week": "04-Apr-2025", "metric": "totalopportunity", "value": 959.8153 }
  //     ]
  //   },
  //     "sqlQuery": "SELECT Column1, Column2, Column3 FROM SampleTable WHERE Condition = 'Value';",
  // }
  } catch (error) {
    throw error;
  }
}
